<template>
  <div>
    <Search
      v-if="url"
      :title="$lang.parvandehSurveyList"
      :allowFields="$lang.surveyParvandehListFields"
      :hiddenFields="hiddenFields"
      :url="url"
      :allowCollapse="false"
      :visibleSearch="true"
      :visibleSettings="true"
      :visibleExport="true"
      :visibleFilters="true"
      :visibleViewCount="true"
      :allowEdit="false"
      :filterCatch="true"
      :showTotals="true"
      :openNewTab="true"
      :visibleAdd="false"
      removeModalSize="lg"
      :defaultViewCount="10"
      :dynamicButtons="dynamicButtons"
      @getPermisson="updatePermissions"
    />
    <b-modal v-model="isAzmoonExecuteModal" hide-header hide-footer>
      <AzmoonExecuteCard
        v-if="isAzmoonExecuteModal"
        :title="$lang.surveyLang.survey_exam_pack_list"
        :parentLoading="azmoonLoading"
        :azmoonData="azmoonData"
        :personCode="pathOr(null, ['person_parvandeh_code'], extraData)"
        :operatorCode="pathOr(null, ['operator_parvandeh_code'], extraData)"
        :referenceCode="pathOr(null, ['operator_person_code'], extraData)"
      />
      <div class="text-right mt-3">
        <b-button
          variant="outline-danger"
          @click="handleCloseAzmoonExecuteModal"
        >
          <mdicon name="close" size="24" />
          {{ $lang.close }}
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Search from "@/components/base/search";
import AzmoonExecuteCard from "@/components/azmoon/azmoonExecuteCard.vue";
import { pathOr } from "ramda";
import { generateApiUrl } from "@/shared/utils";

export default {
  components: {
    AzmoonExecuteCard,
    Search,
  },
  props: {
    code: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      parentPermissions: [],
      hiddenFields: ["created_by", "created_at.jalali"],
      isAzmoonExecuteModal: false,
      dynamicButtons: [
        {
          name: "editView",
          text: this.$lang.showAzmoonExecuteList,
          AllowPermissions: ["admin", "edit", "view"],
          iconFont: {
            name: "account-details-outline",
            size: "24",
            class: "text-primary",
          },
          click: this.handleOpenAzmoonExecuteModal,
        },
      ],
      azmoonData: [],
      extraData: {},
      url: null,
    };
  },
  watch: {
    code: {
      immediate: true,
      handler(val) {
        this.url = null;
        setTimeout(() => {
          this.url = generateApiUrl(
            ["survey", "mySurveyGroupParvandeh"],
            [val]
          );
        }, 300);
      },
    },
  },
  methods: {
    pathOr,
    updatePermissions(permissions) {
      this.parentPermissions = [...permissions];
    },
    async getAzmoonCombo(item) {
      try {
        this.azmoonLoading = true;
        const parvandehNumber = pathOr(
          null,
          ["parvandeh", "parvandeh_number"],
          item
        );
        const url = `${
          this.$config.api_url
        }${this.$config.survey.survey_group_azmoon_combo.replace(
          "{0}",
          this.code
        )}?parvandeh_number=${parvandehNumber}`;
        const response = await this.$httpService.get(url);
        this.azmoonData = pathOr([], ["data", "data", "azmoon"], response);
        this.extraData = pathOr({}, ["data", "data", "extra"], response);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.azmoonLoading = false;
      }
    },
    handleOpenAzmoonExecuteModal(item) {
      this.isAzmoonExecuteModal = true;
      this.getAzmoonCombo(item);
    },
    handleCloseAzmoonExecuteModal() {
      this.isAzmoonExecuteModal = false;
    },
  },
};
</script>
